import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  GetUserPermissionsResponse,
  UpdateUserPermissionsDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateUserPermissions = async ({
  orgId,
  userId,
  payload,
}: {
  orgId: string;
  userId: string;
  payload: UpdateUserPermissionsDto;
}) => {
  const response = await axiosClient.patch(
    `${orgId}/users/${userId}/permissions`,
    payload,
  );
  return response.data;
};

function useUpdateUserPermissions(
  mutationOptions?: UseMutationOptions<
    GetUserPermissionsResponse,
    HttpError,
    { orgId: string; userId: string; payload: UpdateUserPermissionsDto }
  >,
) {
  return useMutation({
    mutationFn: updateUserPermissions,
    ...mutationOptions,
  });
}

export { useUpdateUserPermissions };
